import { IsBoolean, IsOptional, IsString, IsUUID } from 'class-validator';

export class PutServiceProviderDto {
  @IsOptional()
  @IsString()
  name?: string;
  @IsOptional()
  @IsString()
  phone?: string;
  @IsOptional()
  @IsString()
  address?: string;
  @IsOptional()
  @IsString()
  zipCode?: string;
  @IsOptional()
  @IsString()
  city?: string;
  @IsOptional()
  @IsUUID(4)
  countryId?: string;
  @IsOptional()
  @IsBoolean()
  defaultAutoGenerateReceipts?: boolean;
  @IsOptional()
  @IsUUID(4)
  defaultTaxCodeId?: string;
}

export interface ServiceProviderCompanyDto {
  id: string; // global service provider id
  name?: string;
  phone?: string;
  address?: string;
  zipCode?: string;
  city?: string;
  countryId?: string;
  defaultAutoGenerateReceipts: boolean;
  defaultTaxCodeId?: string;
  ownedByPflegenavi: boolean;
  stripeOperatedBy: 'none' | 'pflegenavi' | 'service_provider';
}

export const ServiceProviderControllerDefinition = {
  controller: 'service-provider',
  endpoints: {
    getServiceProvider: {
      method: 'GET',
      url: ':globalServiceProviderId',
      response: undefined as unknown as ServiceProviderCompanyDto,
      body: undefined,
    },
    updateServiceProvider: {
      method: 'PUT',
      url: ':globalServiceProviderId',
      response: undefined as unknown as {
        success: boolean;
      },
      body: PutServiceProviderDto.prototype,
    },
  },
} as const;

export type ServiceProviderControllerResultTypes = {
  [key in keyof (typeof ServiceProviderControllerDefinition)['endpoints']]: (typeof ServiceProviderControllerDefinition)['endpoints'][key]['response'];
};
export type ServiceProviderControllerBodyTypes = {
  [key in keyof (typeof ServiceProviderControllerDefinition)['endpoints']]: (typeof ServiceProviderControllerDefinition)['endpoints'][key]['body'];
};
